import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import Table from 'components/table/Table'
import Pagination from 'components/pagination/Pagination'
import {
  fetchUnlinkedTracks,
  setUnlinkedPage,
} from 'features/crux/tracker/list/trackerListSlice'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import UnLinkedTrackItem from './UnLinkedTrackItem'
import { showCreateTrackModal } from 'features/crux/tracker/modal/create/createTrackSlice'

const UnLinkedTracks = () => {
  const dispatch = useDispatch()
  const {
    unlinkedContent,
    unlinkedPage,
    unlinkedTotalElements,
    unlinkedLoading,
    unlinkedLoadingError,
  } = useSelector(state => state.tracker.trackerList)
  useEffect(() => {
    dispatch(fetchUnlinkedTracks())
  }, [dispatch, unlinkedPage])
  return (
    <>
      <div className="managebox_tit">
        <p className="desc_box">
          내 카카오계정이 마스터/멤버 권한을 갖고 있는 픽셀 &amp; SDK입니다.
          ‘연동하기’버튼을 클릭하면 즉시 광고계정과 연동됩니다.
        </p>
      </div>
      <div className="tblg2_wrap">
        <Table
          className="tbl_g2 tbl_event"
          caption="픽셀 & SDK 전체 표"
          loading={unlinkedLoading}
          error={unlinkedLoadingError}
          errorMessage={
            <>
              일시적인 문제로 픽셀 & SDK를 불러올 수 없습니다.
              <br />
              페이지를{' '}
              <NoneAnchor
                className="link_txt"
                onClick={() => {
                  dispatch(fetchUnlinkedTracks())
                }}>
                새로고침
              </NoneAnchor>{' '}
              하세요.
            </>
          }
          emptyMessage={
            <>
              연동 가능한 픽셀 &amp; SDK가 없습니다.
              <br />
              <NoneAnchor
                className="link_txt"
                onClick={() => dispatch(showCreateTrackModal())}>
                픽셀 &amp; SDK 만들기
              </NoneAnchor>
              를 클릭하여 새로 생성할 수 있습니다.
            </>
          }>
          <Table.Head>
            <Table.Column title="픽셀 & SDK (ID)" />
            <Table.Column
              width={300}
              title={
                <>
                  연동 서비스
                  <HelpTooltip>
                    픽셀 & SDK에 연동된 서비스입니다.
                    <br />
                    마우스오버하면 상세 서비스를 확인할 수 있습니다.
                  </HelpTooltip>
                </>
              }
            />
            <Table.Column
              width={105}
              title={
                <>
                  모수
                  <HelpTooltip>
                    이벤트별로 최근 180일간 수집한 추정 모수입니다.
                  </HelpTooltip>
                </>
              }
            />
            <Table.Column
              width={140}
              title={
                <>
                  이벤트 수집현황
                  <HelpTooltip>
                    픽셀 & SDK로 이벤트가 수집되고 있는 상태입니다.
                    <br />
                    픽셀 & SDK를 설치하거나 서비스를 연동하면 이벤트가
                    수집됩니다.
                  </HelpTooltip>
                </>
              }
            />
            <Table.Column width={178} title="내 권한" />
            <Table.Column width={108} title="광고계정 연동" />
          </Table.Head>
          <Table.Body>
            {unlinkedContent.map(data => (
              <Table.Row key={data.trackId}>
                <UnLinkedTrackItem data={data} />
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {unlinkedTotalElements > 0 && (
        <div className="paging_wrap">
          <div className="inner_paging">
            <Pagination
              current={unlinkedPage}
              total={unlinkedTotalElements}
              onChange={newPage => dispatch(setUnlinkedPage(newPage))}
            />
          </div>
        </div>
      )}
    </>
  )
}
export default UnLinkedTracks
